export default {
  userInfo: null
}
